// extracted by mini-css-extract-plugin
export default {"container":"UserChatMessage_container__9p5f5","message":"UserChatMessage_message__zBenL","actions":"UserChatMessage_actions__wDtgG"};